<template>
  <div class="homepage-hero-module" :style="{opacity: vedioCanPlay ? 1 : 0}">
    <span class="video-close" @click="handleClose">
      <i class="w-icon-guanbi"></i>
    </span>
    <div class="video-container">
      <video id="homePageVideo" :style="videoStyle" height="60%" autoplay loop preload muted class="fillWidth" @error="handleError" @canplay="canplay" controls>
        <source :src="src"/>
        <!--<source src="https://www.w3school.com.cn/i/movie.ogg"/>-->
        浏览器不支持 video 标签，建议升级浏览器。
      </video>
    </div>
  </div>
</template>
<style lang="less" scoped>
  .homepage-hero-module,
  .video-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.3);
    transition: all 0.3s;
    .video-close {
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      z-index: 1001;
      display: -ms-flexbox;
      display: -webkit-box;
      display: flex;
      -ms-flex-align: center;
      -webkit-box-align: center;
      align-items: center;
      -ms-flex-pack: center;
      -webkit-box-pack: center;
      justify-content: center;
      opacity: .8;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-color: rgba(0,0,0,.5);
      height: 80px;
      overflow: hidden;
      right: -40px;
      top: -40px;
      -webkit-transition: background-color .15s;
      transition: background-color .15s;
      width: 80px;
      cursor: pointer;
      &:hover {
        background-color: rgba(0,0,0,.8);
      }
      i {
        color: #fff;
        font-size: 10px!important;
        margin-right: 32px;
        margin-top: 32px;
      }
    }
  }

  .video-container .poster img,
  .video-container video {
    position: absolute;
    /*margin: 0 auto;*/
    /*height: auto;*/
    /*left: 0;*/
    /*bottom: 0;*/
    /*width: 80%;*/
    /*height: 80%;*/
    /*width: 80%;*/
    /*height: 60%;*/
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style>

<script>
export default {
  name: 'VideoPlay',
  data () {
    return {
      vedioCanPlay: false,
      videoStyle: ''
    }
  },
  props: {
    src: {
      type: String,
      required: true
    }
  },
  methods: {
    canplay () {
      this.vedioCanPlay = true
    },
    handleError () {
      this.vedioCanPlay = false
      this.$message.error('视频加载错误，请重试')
      this.$emit('close')
    },
    computeVideoSize () {
      const winW = document.body.clientWidth || document.documentElement.clientWidth
      // const winH = document.body.clientHeight || document.documentElement.clientHeight
      const factor = 1280 / 1920
      const realWidth = Math.floor(winW * factor)
      const realheight = Math.floor(realWidth * 720 / 1280)
      this.videoStyle = `width: ${realWidth}px;height: ${realheight}px`

      // const w = 1280 // 视频源 宽高比 960 / 540 = 16 : 9
      // const h = 693
      // let videoStyle = ''
      // let newW = 1
      // let newH = 1
      // if (winW && winH) {
      //   if ((winW / winH) >= (w / h)) {
      //     // 窗口宽高比 大于视屏源文件 宽高比 按照 宽度 放大(缩小)视频
      //     newW = winW // 视频放大(缩小)后的宽度
      //     newH = (newW * 540) / 960 // 视频放大(缩小)后的高度
      //     const marginTop = -((newH - winH) / 2) // 视频放大(缩小)后 向顶部的偏移
      //     videoStyle = 'margin-top: ' + marginTop + 'px; '
      //   } else {
      //     // 按照 高度 放大(缩小)视频
      //     newH = winH // 视频放大(缩小)后的高度
      //     newW = (960 * newH) / 540 // 视频放大(缩小)后的宽度
      //     const marginLeft = -((newW - winW) / 2) // 视频放大(缩小)后 向顶部的偏移
      //     videoStyle = 'margin-left: ' + marginLeft + 'px; '
      //   }
      //   videoStyle += 'width: ' + newW + 'px; ' + 'height: ' + newH + 'px; visibility: visible; '
      //   if (newW > 1 && newW > 1) {
      //     this.videoStyle = videoStyle
      //   }
      // }
    },
    // 判断视频是否能播放了
    judgeCanplay () {
      this.$nextTick(() => {
        const nowVideo = document.getElementById('homePageVideo')
        if (nowVideo) {
          nowVideo.oncanplay = () => {
            nowVideo.play()
            nowVideo.volume = 0.2
          }
        }
      })
    },
    // 关闭
    handleClose () {
      this.$emit('close')
      document.body.style.overflowY = ''
    }
  },
  mounted () {
    document.body.appendChild(this.$el)
    document.body.style.overflowY = 'hidden'
    this.computeVideoSize()
    this.resizeHandle.resize(() => {
      this.computeVideoSize()
    })
    this.judgeCanplay()
    //  window.onresize = () => {
    //   const windowWidth = document.body.clientWidth
    //   const windowHeight = document.body.clientHeight
    //   const windowAspectRatio = windowHeight / windowWidth
    //   this.videoStyle = {
    //     transform: rotateY(`41.41deg`)
    //   }
    // }
    // window.onresize()
  }
}
</script>
